import { defineMessages } from 'react-intl';

export const rateShopperMessages = defineMessages({
  savingsBanner: {
    defaultMessage: 'Save <savings></savings>! Add <shippingServiceName></shippingServiceName> to this rate shopper',
    id: 'U6eAzl',
    description: 'banner text that shows the amount a user could save with a different service',
  },
  addServiceSuccessContent: {
    defaultMessage: '{serviceName} was added to {rateShopperName} rate shopper. Rerating your open orders.',
    id: 'pVm7pP',
    description: 'notification text when service is added and rerating has started',
  },
  reratingCompleteContent: {
    defaultMessage: 'Your open orders with the updated rate shopper have been rerated.',
    id: 'dP33T5',
    description: 'notification text when all open orders have finished rerating',
  },
  addServiceErrorTitle: {
    defaultMessage: 'Error Adding Service',
    description: 'title for error notification when adding service to collection fails',
    id: 'BjzQUc',
  },
  addServiceErrorContent: {
    defaultMessage: 'Unable to add {serviceName} to your rate shopper. Please try again.',
    description: 'content for error notification when adding service to collection fails',
    id: 'jt22sC',
  },
  refreshServiceErrorTitle: {
    defaultMessage: 'Error Refreshing Services',
    description: 'title for error notification when refreshing service collections fails',
    id: 'FV4crk',
  },
  refreshServiceErrorContent: {
    defaultMessage: '{serviceName} was added but we encountered an error refreshing your data. Please refresh the page.',
    description: 'content for error notification when refreshing service collections fails after successful add',
    id: 'ngCy3n',
  },
});

export const commonMessages = defineMessages({
  closeRateRecommendation: {
    defaultMessage: 'Close Rate Recommendation',
    description: 'Aria label for the close rate recommendation button',
    id: 'y30XK9',
  },
  applyingSavings: {
    defaultMessage: 'Applying savings...',
    description: 'Text displayed when savings are being applied',
    id: 'hNfEC+',
  },
  savingsApplied: {
    defaultMessage: 'You saved {savingsAmount}!',
    description: 'Amount saved by applying rate recommendations',
    id: 'a84j2t',
  },
  addButton: {
    defaultMessage: 'Add',
    id: '8IpCor',
    description: 'button text to add recommendation to collection',
  },
});
